import {Injectable} from '@angular/core';
import { isNullOrUndefined } from '@shared/utils/utils';


@Injectable({
  providedIn: 'root'
})
export class TenantService {
  public static sorrentoParameters: any[];
  public static uploadParameters: any[];
  public static zoomParameters: any[];
  public static cognitoParameters: any[];

  static loadConfiguration(): Promise<any>{
    let tenant;
    let baseUrlTenantApi;
    const basePathTenantApi = 'v1/public.cloud.docbyte';
    if(location.href.includes('localhost')){
      tenant = 'devteam';
      baseUrlTenantApi = 'https://tenantconfig.dev.docbyte.cloud';
    } else{
      tenant = location.href.split('.')[1];
      const regex = /https?:\/\/([^/]*)/;
      baseUrlTenantApi = 'https://tenantconfig.' + regex.exec(location.href)[1].split('.').slice(2).join('.');
    }
    let url = `${baseUrlTenantApi}/${basePathTenantApi}.${tenant}.sorrento`;
    const sorrentoRequest = fetch(url).then(res => res.json());
    url = `${baseUrlTenantApi}/${basePathTenantApi}.${tenant}.upload`;
    const uploadRequest = fetch(url).then(res => res.json());
    url = `${baseUrlTenantApi}/${basePathTenantApi}.${tenant}.zoom`;
    const zoomRequest = fetch(url).then(res => res.json());
    url = `${baseUrlTenantApi}/${basePathTenantApi}.${tenant}.cognito`;
    const cognitoRequest = fetch(url).then(res => res.json());
    return Promise.all([sorrentoRequest, uploadRequest, zoomRequest, cognitoRequest]).then((values) => {
      this.sorrentoParameters = values[0].body.parameters;
      this.uploadParameters = values[1].body.parameters;
      this.zoomParameters = values[2].body.parameters;
      this.cognitoParameters = values[3].body.parameters;
      console.log('tenant service params loaded ' + this.sorrentoParameters[0]?.name)
    });
  }

  public getParameter(service: string, name: string){
    let value = null;
    if (service === "sorrento" && !isNullOrUndefined(TenantService.sorrentoParameters)){
      value = TenantService.sorrentoParameters.find(param => param.name.includes(name)).value;
    }
    else if (service === "upload" && !isNullOrUndefined(TenantService.uploadParameters)){
      value = TenantService.uploadParameters.find(param => param.name.includes(name)).value;
    }
    else if (service === "zoom" && !isNullOrUndefined(TenantService.zoomParameters)){
      value = TenantService.zoomParameters.find(param => param.name.includes(name)).value;
    }
    else if (service === "cognito" && !isNullOrUndefined(TenantService.cognitoParameters)){
      value = TenantService.cognitoParameters.find(param => param.name.includes(name)).value;
    }
    return value === "none" ? "" : value;
  }
}
